import { render, staticRenderFns } from "./ConfigTabDialog.vue?vue&type=template&id=33217d99&"
import script from "./ConfigTabDialog.vue?vue&type=script&lang=js&"
export * from "./ConfigTabDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports